<template>
  <div>
    <div class="" style="width: 100%">
      <div class="m10">
        <el-button type="primary" @click="exportPDF">导出PDF到本地</el-button>
      </div>
      <div id="export-html" class="p2">
        <table width="100%" cellpadding="0" cellspacing="0">
          <tbody>
            <tr>
              <td colspan="8">{{ Training.Title }}</td>
            </tr>
            <tr>
              <td rowspan="4">
                <img
                  :src="$matrix.Config.ImageSite + Users.FaceImage"
                  style="width: 200px; height: 300px"
                />
              </td>
              <td colspan="2">姓名</td>
              <td colspan="2">{{ Users.NickName }}</td>
              <td>行业类别</td>
              <td colspan="2">道路尾货运输</td>
            </tr>
            <tr>
              <td colspan="2">性别</td>
              <td colspan="2">{{ Users.Sex === 1 ? "男" : "女" }}</td>
              <td>学员身份</td>
              <td colspan="2">{{ Users.Category.Name }}</td>
            </tr>
            <tr>
              <td colspan="2">身份证号</td>
              <td colspan="2">{{ Users.IDCard }}</td>
              <td>所在地区</td>
              <td colspan="2">辽宁省-阜新市-市辖 区</td>
            </tr>
            <tr>
              <td colspan="2">所在企业</td>
              <td colspan="6">{{ Users.Company.Name }}</td>
            </tr>
            <tr>
              <td colspan="8">学习信息</td>
            </tr>
            <tr>
              <td>教材</td>
              <td>教材总时长</td>
              <td>完成学习时长</td>
              <td>最后学习时间</td>
              <td>完成情况</td>
              <td colspan="3">学员签字</td>
            </tr>
            <tr v-for="(item, index) in RecordList" :key="index">
              <td>{{ item.Parent.Name }}</td>
              <td>{{ getDuration(item.Parent.Duration) }}</td>
              <td>{{ getDuration(item.Parent.Duration) }}</td>
              <td>{{ item.LastLearnDate }}</td>
              <td>{{ item.IsComplete ? "已完成" : "未完成" }}</td>
              <td colspan="3">签字</td>
            </tr>
            <tr>
              <td colspan="2">教材名称</td>
              <td colspan="6">学习内容</td>
            </tr>
            <tr v-for="(item, index2) in VideosList" :key="index2 + item.Name">
              <td colspan="2">{{ item.Name }}</td>
              <td colspan="6">{{ item.Description }}</td>
            </tr>

            <tr>
              <td colspan="8">考试信息</td>
            </tr>
            <tr>
              <td>考试名称</td>
              <td>考试时间</td>
              <td>试卷总分</td>
              <td>学员成绩</td>
              <td>考试结果</td>
              <td colspan="4">学员签字</td>
            </tr>
            <tr>
              <td>{{ value.Parent.Name }}</td>
              <td>{{ value.Parent.CreateTime }}</td>
              <td>{{ 100 }}</td>
              <td>{{ value.ExamScore }}</td>
              <td>{{ value.ExamResult === 2 ? "合格" : "不合格" }}</td>
              <td colspan="4">
                <img
                  :src="$matrix.Config.ImageSite + SignImagePath"
                  style="width: 150px; height: 120px"
                  v-if="SignImagePath"
                />
              </td>
            </tr>
            <tr>
              <td colspan="8">
                {{ value.Parent.Name }}（{{ value.Parent.Paper.TopicCount }}题）
              </td>
            </tr>
            <tr>
              <td>序号</td>
              <td>题目</td>
              <td>题型</td>
              <td>答案</td>
              <td>学员答案</td>
              <td>题目分数</td>
              <td>得分</td>
              <td>结果</td>
            </tr>
            <tr v-for="(item, index) in value.TopicList" :key="index + '_' + item.Id">
              <td>{{ index + 1 }}</td>
              <td>{{ item.Name }}</td>
              <td>{{ item.ModuleTypeTitle }}</td>
              <td>{{ item.Answer }}</td>
              <td>{{ item.UserAnswer }}</td>
              <td>{{ item.Score }}</td>
              <td>{{ item.TestScore }}</td>
              <td>{{ item.TestResult }}</td>
            </tr>
            <tr>
              <td colspan="8">考试抽检照片</td>
            </tr>
            <tr v-if="value.FaceList.length">
              <td colspan="8">
                <el-image
                  :src="$matrix.Config.ImageSite + item.FaceImage"
                  style="width: 10%; margin-right: 10px"
                  v-for="(item, index) in value.FaceList"
                  :key="index + 'face_'"
                  fit="scale-down"
                />
              </td>
            </tr>
          </tbody>
        </table>

        <div class="flex-row p2 f16">
          <div>所属单位安全教育培训管理部门签章：</div>
          <div class="rel">
            网络安全教育平台 <el-image src="/static/system/zhang.png" class="abs" />
          </div>
        </div>
        <div class="flex-row p2 end"></div>
        <div class="flex-row p2">
          <div class="wf end flex-row rel">{{ ExamDate }}</div>
          <div class="wf end flex-row rel">{{ ExamDate }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { jsPDF as JsPDF } from "jspdf";
import html2Canvas from "html2canvas";

export default {
  props: {
    value: Object,
    config: Object,
  },
  computed: {
    LearnRecord() {
      return [];
    },
    Users() {
      if (this.value && this.value.Users) {
        return this.value.Users;
      }
    },
    Training() {
      if (this.value.Training) {
        return this.value.Training;
      }
    },
    VideosList() {
      if (this.Training) {
        return this.Training.VideosList;
      }
    },
    RecordList() {
      if (this.VideosList) {
        let res = [];
        this.VideosList.forEach((item) => {
          res = res.concat(item.RecordList);
        });
        return res;
      }
    },
    ExamDate() {
      if (this.value) {
        return this.value.ExamStartTime.substr(0, 11);
      }
    },
    SignImagePath() {
      if (
        this.value &&
        this.value.Parent &&
        this.value.Parent.SignList &&
        this.value.Parent.SignList.length
      ) {
        let res = this.value.Parent.SignList.find((t) => {
          return t.Users.Id === this.value.Users.Id;
        });
        if (res) return res.SignImagePath;
      }
    },
  },
  methods: {
    exportPDF() {
      const scale = 3;
      html2Canvas(document.querySelector("#export-html"), {
        allowTaint: true, // 允许 canvas 污染
        scale, // 缩放比例
      }).then((canvas) => {
        const contentWidth = canvas.width / scale;
        const contentHeight = canvas.height / scale;
        const PDF = new JsPDF("", "pt", [contentWidth, contentHeight]);
        const pageData = canvas.toDataURL("image/jpeg", 1.0);
        // 此处没有做分页处理，
        // 如果需要做分页处理，只需在高度上做处理，并记录每次截取的高度
        // 根据每次的高度计算切分的个数，然后再一个一个拼接起来
        PDF.addImage(pageData, "JPEG", 0, 0, contentWidth, contentHeight);
        PDF.save(document.title + Date.now() + ".pdf");
      });
    },
    getDuration(seconds) {
      let m = Math.floor(seconds / 60);
      let s = Math.floor(seconds % 60);
      return `${m > 9 ? m : "0" + m}分${s > 9 ? s : "0" + s}秒`;
    },
  },
};
</script>
<style scoped>
table {
  border: 2px solid #000;
}
table tr td {
  font-size: 16px !important;
  padding: 20px;
  border: 1px solid #000;
  text-align: center;
}
.rel {
  position: relative;
  z-index: 999;
}
.abs {
  position: absolute;
  right: 0;
  z-index: -1;
}
</style>
